import {
  FormAlertMessageKindDTO,
  type FormFieldAlertMessageResponseDTO,
} from '@/api/base/DTOs';
import type { FormAlertMessage } from '@/forms/typings';

export const adaptFormFieldAlertMessageResponse = (
  alertMessage: FormFieldAlertMessageResponseDTO,
): FormAlertMessage => {
  const variants: Record<
    FormFieldAlertMessageResponseDTO['kind'],
    FormAlertMessage['variant']
  > = {
    [FormAlertMessageKindDTO.Primary]: 'color',
    [FormAlertMessageKindDTO.Neutral]: 'neutral',
    [FormAlertMessageKindDTO.Warning]: 'warning',
    [FormAlertMessageKindDTO.Danger]: 'danger',
  };

  return {
    value: alertMessage.value,
    variant: variants[alertMessage.kind],
  };
};
